import React from 'react';
import Description from './Description';

interface TitleSubcategoryProps {
    category: any;
    className: string;
}

const TitleSubcategory = ({
    category,
    className
}: TitleSubcategoryProps) => {

    return (
        <h3 className={`flex items-center gap-4 ${className}`}>
            <div className='flex flex-col gap-1.5 w-full'>
                <div className='flex gap-4'>
                    <span className='text-base md:text-base text-justify font-bold md:font-semibold text-custom-primary leading-none md:leading-none md:text-left md:opacity-85'>
                        { category.name }
                    </span>
                    <hr className='flex flex-1 opacity-50 border min-w-14 mt-2.5' />
                </div>

                <Description description={category.description} wordLimit={20} className='text-sm md:text-base leading-4' />
            </div>
        </h3>
    );
};

export default TitleSubcategory;
